<template>
  <div class="fullWidth">
    <ClientProfileTabs></ClientProfileTabs>
  </div>




</template>

<script>
import axios from 'axios'
import ClientProfileTabs from '@/components/ui/ClientProfileTabs.vue'


export default {
  metaInfo() {
    return {
      title: this.$i18n.t('profile'),
    }
  },
  components: {
    ClientProfileTabs
  },
  data() {
    return {
      id: this.client.id,  //! NE NAJDE client.id //
      isEditing: false,
      isLoading: true,
      products: [],
      prodInfo: null,
      loading: true,
      errored: false
    }
  },

  created() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/dashboard`)
      .then(response => {
        // handle success
        this.products = response.data.products.products
        this.isLoading = false
      })
      .catch(error => {
        // handle error
        console.log(error)
      })
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/cleaners`)
      .then(response => {
        this.cleanerInfo = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))
  },
  methods: {
    changeClientDetails() {
      if (
        confirm('Are you sure? This will rewrite your existing account details')
      ) {
        this.$store.dispatch('client/editClient', this.id)
      }
    },
    deleteCleaner() {
      if (confirm('are you sure?')) {
        this.$store
          .dispatch('cleaner/removeCleaner', this.id)
          // .then(() => {
          //   this.$router.push({
          //     path: '/products'
          //   })
          // })
          .catch(e => console.log(e))
      }
    },
    updateProfile(e) {
      this.$emit("updateProfile", e);
    }
  },
  props: {
    client: {
      type: Object,
      required: true
    },
    cleaner: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>

.fullWidth {
	width: 100%;
}

.add-btn {
	background: var(--primaryDark);
	color: var(--bright);
	padding: 1em;
	letter-spacing: 3px;
	border-radius: 5px;
	width: 60%;
}

.keepCenter {
  align-content: center;
  justify-content: center;
}

@media screen and (max-width: 780px){
  .add-btn {
  width: 80%;
}
}

</style>
